import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { editorUpdatePrimaryColor, editorUpdateSecondaryColor } from '../../../../../../store/pages-management/actions'
import { ThemeProps as Props } from './types'

const Theme: FC<Props> = ({ strings, colors }) => {
  // REDUX STORE
  const dispatch = useDispatch()

  return (
    <div className="part theme">
      <h3 className="part_header">{strings.theme}</h3>
      <div>
        <div
          className="grey picker"
          onClick={() => document.getElementById('base')?.click()}
          role="presentation"
        >
          <div className="color-preview" style={{ backgroundColor: colors.primary }} />
          <span>{strings.base_color}</span>
          <input
            type="color"
            id="base"
            hidden
            onChange={(e) => dispatch(editorUpdatePrimaryColor(e.target.value))}
          />
        </div>
        <div
          className="grey picker"
          onClick={() => document.getElementById('accent')?.click()}
          role="presentation"
        >
          <div className="color-preview" style={{ backgroundColor: colors.secondary }} />
          <span>{strings.accent_color}</span>
          <input
            type="color"
            id="accent"
            hidden
            onChange={(e) => dispatch(editorUpdateSecondaryColor(e.target.value))}
          />
        </div>
      </div>
    </div>
  )
}

export default Theme